/**
 * Opens the first rendered accordion row inside a product accordion.
 * Empty rows are omitted server-side, so the first child is always the first available item.
 */
class ProductAccordion extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => {
      this.#openFirstAvailableRow();
    });
  }

  #openFirstAvailableRow() {
    const firstAccordion = this.querySelector('accordion-custom');

    if (!(firstAccordion instanceof HTMLElement)) return;

    const alreadyOpenByDefault =
      firstAccordion.hasAttribute('open-by-default-on-desktop') ||
      firstAccordion.hasAttribute('open-by-default-on-mobile');

    if (!alreadyOpenByDefault) {
      firstAccordion.setAttribute('open-by-default-on-desktop', '');
      firstAccordion.setAttribute('open-by-default-on-mobile', '');
    }

    const details = firstAccordion.querySelector('details');

    if (details instanceof HTMLDetailsElement) {
      details.open = true;
    }
  }
}

if (!customElements.get('product-accordion')) {
  customElements.define('product-accordion', ProductAccordion);
}
